const mapStateToProps = (state) => {
    const {
        api:{
            user,
        }={},
        service:{
            Api:{
                userLogin
            }={}
        }={}
    } = state;
    return { user, userLogin,  }
}

export default mapStateToProps;